import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import useUser from '../../hooks/useUser';

const RequestHistorySide = () => {
  const { isNewUser } = useUser();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mt: 5,
        justifyContent: 'center',
        flexDirection: 'column',
        px: 6,
      }}
    >
      <Typography
        sx={{ my: 4, fontSize: '30px', borderBottom: '1px solid black' }}
      >
        Δείτε Επίσης
      </Typography>
      {!isNewUser && (
        <Typography
          component={Link}
          to="/registry-review"
          sx={{ color: 'link.main', px: 0.5 }}
        >
          Στοιχεία μητρώου
        </Typography>
      )}
    </Box>
  );
};

export default RequestHistorySide;
